import React from "react";
import "./Orders.css";
import { Container, Row, Col, Modal, Button } from "react-bootstrap"; // Import Modal and Button
import OrdersImg from "./../../Images/orders.png"; // Keep if still used elsewhere
import { useState, useCallback } from "react";
import { useEffect } from "react";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import ConvertTime from "../../Common/ConvertTime";
import { useNavigate } from "react-router-dom";
import { fetchAllOrder } from "../../Actions/adminActions";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
// import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import moment from "moment";
import debounce from "lodash.debounce";
import apiCall from "../../API/API";

const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { orders } = useSelector((state) => state.admin);
  const [filter, setFilter] = useState("none");
  const [data, setData] = useState([]); // This state seems unused, consider removing if not needed.
  const [search, setsearch] = useState({
    status: "",
    amount: "",
    username: "",
    search: "",
    startDate: "",
    endDate: "",
    uid: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // States for the Turbo Boost Status Modal
  const [showBoostModal, setShowBoostModal] = useState(false);
  const [selectedBoostData, setSelectedBoostData] = useState(null); // This will hold the entire 'turbo_boost' object

  const handleCloseBoostModal = () => setShowBoostModal(false);
  const handleShowBoostModal = (boostData) => {
    setSelectedBoostData(boostData); // Pass the whole turbo_boost object here
    setShowBoostModal(true);
  };

  const fetchOrders = useCallback(
    debounce((params) => {
      dispatch(fetchAllOrder(params));
    }, 500),
    [dispatch]
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    // No need to call fetchOrders here as useEffect will handle it based on search state changes
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    dispatch(fetchAllOrder(queryParams));
  };

  const resetFilter = () => {
    const queryParams = {
      page: "1",
      limit: 20,
    };
    dispatch(fetchAllOrder(queryParams));
    setsearch({
      amount: "",
      username: "",
      search: "",
      startDate: "",
      endDate: "",
      status: "",
      uid: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchOrders(queryParams);
  }, [
    dispatch,
    currentPage,
    limitFilter,
    search,
    startDate,
    endDate,
    fetchOrders,
  ]);

  useEffect(() => {
    setTotalRecords(orders?.totalRecords);
    setTotalPages(orders?.totalPages);
  }, [orders]);

  const [totalRecord, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);

  const handleExportExcel = async () => {
    try {
      const { data } = await apiCall(
        "GET",
        `/get_all_orders?limit=${totalRecord}`,
        null,
        false
      );

      setExportData(data?.data);
    } catch (error) {
      console.error("Failed to export data:", error);
      // toast.error("Failed to export data"); // Assuming toast is available
    }
  };
  useEffect(() => {
    if (totalRecord > 0) {
      handleExportExcel();
    }
  }, [totalRecord]);

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <p className="m-0">
            Home / <span>Orders</span>
          </p>
          <div>
            {/* <ExportExcel
              data={exportData}
              columns={[
                "name",
                "username",
                "amount",
                "package_type",
                "order_Date",
                "maturity_Date",
              ]}
              fileName="orders.xlsx"
            /> */}
          </div>
        </div>
        <Row id="filterRow">
          <span id="filterLogo">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
            </div>
            <div className="align-content-center">
              Total Debited Amount : {orders?.Sum}
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="amount"
                  placeholder="Search By Amount"
                  value={search.amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            {/*<Col lg="2" md="4">
              <div>
              
              <input type="text" name='username' placeholder="Search By UserName" value={search.username} onChange={handleChange} />
                </div>
            </Col>*/}
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          {/*<div id="ordersImg"><img src={OrdersImg} alt="" /></div>*/}

          <Row id="directTableRow" className="">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th>S No.</th>
                    <th>Username</th>
                    <th>Wallet Address</th>
                    <th>Uid</th>
                    <th>Amount</th>
                    <th>Package Date&Time</th>
                    <th>Package Status</th>
                    {/* Add new header for the Status button */}
                    {/* <th>Turbo Boost Status</th> */}
                  </tr>
                  <tbody>
                    {orders?.data?.map((x, i) => {
                      const turboBoostStatus =
                        x?.turbo_boost?.turbo_boost_status;
                      const turboBoostDetails = x?.turbo_boost; // This object contains all turbo_boost related data

                      return (
                        <tr key={i}>
                          <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                          <td>{x?.username}</td>
                          <td>{x?.wallet_address}</td>
                          <td>{x?.uid}</td>
                          <td>{x?.amount}</td>
                          <td>
                            {moment(x?.added_on).format("MM-DD-YYYY & HH:mm")}
                          </td>
                          {x?.status === 1 ? (
                            <td>Approved</td>
                          ) : (
                            <td>Pending</td>
                          )}
                          {/* New column for the status button */}
                          {/* <td>
                              <Button
                              {...turboBoostStatus?.is_boosted ? { variant: "success" } : { variant: "secondary" }}
                                onClick={() => handleShowBoostModal(turboBoostDetails)}
                              >
                                Status
                              </Button>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>

      {/* Turbo Boost Status Modal */}
      <Modal show={showBoostModal} onHide={handleCloseBoostModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Turbo Boost Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBoostData && selectedBoostData.turbo_boost_status ? (
            <>
              {/* Display boost_level, current_percentage, description at the top */}
              {/* <div style={{ textAlign: 'left' }}> */}
              <p style={{ textAlign: "left" }}>
                <strong>Boost Level:</strong>{" "}
                {selectedBoostData.turbo_boost_status.boost_level}
              </p>
              <p style={{ textAlign: "left" }}>
                <strong>Current Percentage:</strong>{" "}
                {selectedBoostData.turbo_boost_status.current_percentage}
              </p>
              <p style={{ textAlign: "left" }}>
                <strong>Days since Order:</strong>{" "}
                {selectedBoostData.turbo_boost_status.days_since_order}
              </p>
              <p style={{ textAlign: "left" }}>
                <strong>Description:</strong>{" "}
                {selectedBoostData.turbo_boost_status.description}
              </p>
              {/* </div> */}
              <hr /> {/* Separator */}
              <h5>Assigned Orders:</h5>
              {selectedBoostData.direct_connections.assigned_orders &&
              selectedBoostData.direct_connections.assigned_orders.length >
                0 ? (
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  {" "}
                  {/* Scrollable area for the table */}
                  <table className="table table-bordered table-striped">
                    {" "}
                    {/* Added some basic styling classes */}
                    <tr>
                      <th>S No.</th>
                      <th>Referral Name</th>
                      <th>Referral Username</th>
                      <th>Amount</th>
                      <th>Order ID</th>
                      <th>Added On</th>
                    </tr>
                    <tbody>
                      {selectedBoostData.direct_connections.assigned_orders.map(
                        (order, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{order.referral_name || "N/A"}</td>
                            <td>{order.referral_username || "N/A"}</td>
                            <td>{order.amount}</td>
                            <td>{order.orderId}</td>
                            <td>
                              {moment(order.added_on).format(
                                "MM-DD-YYYY HH:mm"
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>No assigned orders found for this boost.</p>
              )}
            </>
          ) : (
            <p>No turbo boost data available for this entry.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseBoostModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Orders;
